function Contact() {
  return <h1>Kontakt stranica</h1>;
}

export default Contact;